export default [
  {
    path: '/myPatient',
    name: 'myPatient',
    meta: { title: '我的就诊人' },
    component: () => import(/* webpackChunkName: "patient" */ '../views/myPatient/myPatient')
  },
  {
    path: '/addPatient',
    name: 'addPatient',
    meta: { title: '添加就诊人' },
    component: () => import(/* webpackChunkName: "patient" */ '../views/addPatient/addPatient')
  },
  {
    path: '/patientInfo',
    name: 'patientInfo',
    meta: { title: '就诊人详情' },
    component: () => import(/* webpackChunkName: "patient" */ '../views/patientInfo/patientInfo')
  }
]
